<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card
            class="mb-2"
            header="Liberação de Pagamentos com Erro"
            header-tag="header"
          >
            <div class="row mb-2">
              <div class="col-3">
                <b-input placeholder="CPF" v-model="cpf_requerente"></b-input>
              </div>
              <div class="col">
                <b-button variant="primary" @click="listar">
                  <font-awesome-icon :icon="['fas', 'search']" /> Pesquisar
                </b-button>
              </div>
            </div>
            <b-table
              no-provider-paging
              small
              bordered
              responsive
              :current-page="tabela.currentPage"
              :empty-text="tabela.emptyText"
              :fields="tabela.fields"
              :items="tabela.items"
              :per-page="tabela.perPage"
              :show-empty="tabela.showEmpty"
              :striped="tabela.striped"
            >
              <template v-slot:cell(acoes)="data">
                <b-button
                  variant="primary"
                  size="sm"
                  style="font-size: 12px"
                  @click.prevent="liberarParaEnvio(data.item)"
                  v-if="
                    $store.getters.userRoles.includes(
                      $constantes.usuario.ROLES.SUPERADMINISTRADOR
                    )
                  "
                  title="Liberar para Envio"
                >
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="mr-1"
                  />Liberar para Envio
                </b-button>
              </template>
            </b-table>
            <template v-slot:footer>
              <div class="float-left">
                <b-input-group prepend="Quantidade de Registros">
                  <b-input disabled :value="tabela.items.length"></b-input>
                </b-input-group>
              </div>
              <div class="float-right">
                <b-pagination
                  align="right"
                  :total-rows="tabela.totalRows"
                  v-model="tabela.currentPage"
                  :per-page="tabela.perPage"
                >
                </b-pagination>
              </div>
            </template>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cpf_requerente: "",
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "cpf_requerente",
            label: "CPF",
            class: "text-center",
          },
          {
            key: "nome_completo",
            label: "Nome",
            class: "text-center",
          },
          {
            key: "acoes",
            label: "",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 10,
        totalRows: 0,
      },
    };
  },

  methods: {
    liberarParaEnvio(item) {
      this.$helpers
        .modalConfirmacao(
          this,
          "Liberação para Envio",
          "Deseja realmente liberar pagamento para o CPF:" +
            item.cpf_requerente +
            "?",
          "primary",
          "SIM"
        )
        .then((value) => {
          if (value) {
            this.$api
              .put(`pagamentos/${item.id}/alterar-status`)
              .then((response) => {
                if (response.status == 200) {
                  this.tabela.items = [];
                  this.tabela.items = response.data.dados;
                  this.tabela.totalRows = response.data.dados.length;
                  this.$helpers.showToast(
                    this,
                    "Sucesso",
                    response.data.message,
                    "success"
                  );
                }
              })
              .catch((error) => {
                if (error.response.data) {
                  this.$helpers.showToast(
                    this,
                    "Erro",
                    error.response.data.message,
                    "danger"
                  );
                }
              });
          }
        });
    },

    listar() {
      this.$api
        .get(
          `pagamentos/pagamento-com-erro?cpf_requerente=${this.cpf_requerente}`
        )
        .then((response) => {
          if (response.status == 200) {
            this.tabela.items = [];
            this.tabela.items = response.data.dados;
            this.tabela.totalRows = response.data.dados.length;
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },
  },

  mounted() {
    this.listar();
  },
};
</script>

<style scoped>
</style>
